<template>
  <div>
    <Breadcrumb :style="{margin: '24px 0'}">
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>公告管理</BreadcrumbItem>
        <BreadcrumbItem>公告列表</BreadcrumbItem>
    </Breadcrumb>
    <Content :style="{padding: '24px', minHeight: '580px', background: '#fff'}">
        <div style="height:50px;">
          <div style="float:left">
            <Button type="primary" @click="addArticle()">添加公告</Button>
          </div>
          <div style="float:right;">
            <Button  icon="ios-search" style="float:right;margin-left:5px;" @click="getpage()">Search</Button>
            <Input v-model="search" style="float:right;width:250px;"/>
          </div>
        </div>

        <div>
          <Table border ref="selection" :columns="columns7" :data="data"></Table><br>
          <span style="align:center" >
            <span v-if = "$route.query.page == undefined ">
              <Page :total="page" :page-size="10" :current="1"  @on-change="getpage" ></Page>
            </span>
            <span v-else>
              <Page :total="page" :page-size="10" :current="parseInt($route.query.page)"  @on-change="getpage" ></Page>
            </span>
          </span>
        </div>
        <!-- 弹出框代码start -->
        <Modal
            v-model="modal1"
            @on-ok="ok"
            @on-cancel="cancel">
            <p>是否删除这条记录？</p>
        </Modal>
        <!-- 弹出框代码end -->

        <!-- 弹出框代码start -->
        <Modal v-model="addbrand" @on-ok="ok_addbrand" @on-cancel="cancel_addbrand" title="公告">
            <div class="modeldiv">
              <p class="catename"><b>公告内容</b></p><br/>
              <Input v-model="content" type="textarea" :rows="4" placeholder="请输入文字……" /><br><br>
            </div>
        </Modal>
        <!-- 弹出框代码end -->
    </Content>
  </div>
</template>
<style scoped>
.info {
  border-radius: 10px;
  line-height: 20px;
  padding: 10px;
  margin: 10px;
  background-color: #ffffff;
}
</style>
<script>
import notice from '@/assets/js/views/notice/notice';

export default {
  ...notice,
};
</script>

